<script>
  import Button from '@components/buttons/button.svelte'
  import { DropdownMenu } from 'bits-ui'
  import { CheckCircle } from 'lucide-svelte'
  import { router } from '@inertiajs/svelte'
  import TriggerButton from '@components/general/trigger-button.svelte';
  import { cn } from '@lib/utils'
  
  let { 
    open = $bindable(false),
    disabled = false,
    text,
    trigger,
    showTriggerButton = true,
    contents,
    buttonClass,
    buttonProps = {},
    class: className,
    contentClass = '',
    width = '18rem',
    height = '400px',
    offset = 10,
    align = 'end',
    side = 'bottom',
    itemSize = 'md',
    closeOnSelect = true 
  } = $props()
  
  function handleSelect(item) {
    if (item.externalPath) {
      window.open(item.externalPath, item.target ?? "_blank", "noopener,noreferrer")
    } else if (item.path) {
      router.visit(item.path)
    } else {
      item.onSelect?.()
    }
    const shouldClose = item.closeOnSelect ?? closeOnSelect
    shouldClose && (open = false)
  }

  function handleEscapeKeydown(event) {
    event.preventDefault() // This stops other window escape behaviour higher up also closing other modals etc
  }

  let dropdownDisabled = $derived(disabled || buttonProps.disabled)

</script>

{#snippet item(item)}
  {@const shouldClose = item.closeOnSelect ?? closeOnSelect}
  {@const { externalPath, path, target, onSelect, closeOnSelect: _closeOnSelect, ...buttonItem } = item}
  <DropdownMenu.Item textValue={item.text} onSelect={() => handleSelect(item)}>
    {#snippet child({ props })}
      <Button variant="menu_item" class="w-full"
        text={item.text}
        BeforeIcon={item.icon}
        {...buttonItem}
       {...props} />
    {/snippet}
  </DropdownMenu.Item>
{/snippet}

<div class={className}>
  
  <DropdownMenu.Root bind:open>

    <DropdownMenu.Trigger disabled={dropdownDisabled}>
      {#snippet child({ props })}
        {#if trigger}
          {@render trigger({ open, props })}
        {:else}
          <TriggerButton {disabled} {open} {showTriggerButton} {...buttonProps} {...props} />
        {/if}
      {/snippet}
    </DropdownMenu.Trigger>

    <DropdownMenu.Portal>

      <DropdownMenu.Content 
        class={cn(`bg-white shadow-xl border border-gray-200/60 rounded-md py-2 overflow-y-auto z-60`, contentClass)} 
        style={`max-height: ${height}; width: ${width};`}
        {align} {side} sideOffset={offset} onEscapeKeydown={handleEscapeKeydown}>
        <DropdownMenu.Group class="divide-y divide-gray-100">
          {@render contents?.(item)}
        </DropdownMenu.Group>
      </DropdownMenu.Content>

    </DropdownMenu.Portal>

  </DropdownMenu.Root>

</div>